import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"phone\"><path d=\"M14.89 23.654C7.523 27.021-3.912 4.794 3.289 1.039L5.396 0l3.492 6.817-2.082 1.026c-2.189 1.174 2.37 10.08 4.609 8.994.091-.041 2.057-1.007 2.064-1.011L17 22.621c-.008.004-1.989.978-2.11 1.033zm-1.538-13.409l2.917.87a3.03 3.03 0 0 0-.24-2.317 3.033 3.033 0 0 0-1.808-1.469l-.869 2.916zm1.804-6.058a6.302 6.302 0 0 1 3.756 3.051 6.3 6.3 0 0 1 .498 4.813l-1.795-.535a4.434 4.434 0 0 0-.352-3.387 4.422 4.422 0 0 0-2.643-2.146l.536-1.796zM16.106 1a9.61 9.61 0 0 1 5.729 4.656A9.61 9.61 0 0 1 22.596 13l-1.84-.548a7.709 7.709 0 0 0-.608-5.882 7.704 7.704 0 0 0-4.591-3.729L16.106 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/phone.svg
// module id = tegb
// module chunks = 1